<template>
    <div id="create-campaign">
        <div class="app-container my-5" v-show="!$global.loading">

            <div class="page-title mb-3">
                <router-link to="/campaigns">
                    <span class="breadcrumb-link">
                        <v-icon class="breadcrumb-link-icon">dashboard</v-icon> Campagnes
                    </span>
                </router-link>
                <v-icon>keyboard_arrow_right</v-icon>
                <div class="breadcrumb-item">
                    <span v-if="!update">
                        <v-icon class="breadcrumb-item-icon">mdi-calendar-arrow-right</v-icon> Programmation d'une
                        relance
                        <span v-if="campaign.aspect"> - {{aspectLabel}}</span>
                    </span>
                    <div v-else>
                        <span v-if="campaign.batches.length > 1">
                            <v-icon class="breadcrumb-item-icon">edit</v-icon> Modification d'une relance
                            <span v-if="campaign.aspect"> - {{aspectLabel}}</span>
                        </span>
                        <span v-else>
                            <v-icon class="breadcrumb-item-icon">edit</v-icon> Modification d'un 1er envoi
                            <span v-if="campaign.aspect"> - {{aspectLabel}}</span>
                        </span>
                    </div>
                </div>
            </div>

            <v-text-field v-model="campaign.name" background-color="white" label="Nom de votre campagne" outlined>
            </v-text-field>

          <v-alert type="info" text class="mb-5" v-if="!providers.length">
            😎  Vous n’avez plus de prestataires à relancer ! Félicitations !
          </v-alert>

            <v-stepper @change="setCurrentStep" non-linear :value="currentStep">
                <v-stepper-header>
                    <v-stepper-step editable step="1">
                        Prestataires ({{ providers.length }})
                    </v-stepper-step>

                    <v-stepper-step editable step="2">
                        Contenu de l'e-mail
                    </v-stepper-step>

                    <v-stepper-step editable step="3">
                        Finaliser
                    </v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <verification :is-revival="true" :providers="providers" :aspect="campaign.aspect"
                            :contacts="contacts">
                        </verification>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                        <email v-if="providers.length"></email>
                    </v-stepper-content>

                    <v-stepper-content step="3">
                        <finalize :providers="providers" :cmaj-name="campaign.name" :is-revival="true"
                            v-if="providers.length" :criterias="criterias" :update-mode="update"
                            :batch-id="campaign.last_batch.id" :cmaj-id="cmajId" :cmaj="campaign">
                        </finalize>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Verification from "./stepers/Verification"
import Email from "./stepers/Email"
import Finalize from "./stepers/Finalize"
import * as EmailValidator from "email-validator";
import { aspectElements } from "../../../static/webform"

export default {
    name: "CmajRevival",
    props: ['updateMode'],
    components: { Finalize, Email, Verification },
    data() {
        return {
            cmajId: null,
            campaign: { batches: [] },
            contacts: [],
            update: false,
            criterias: []
        }
    },
    methods: {
        ...mapMutations('createCmaj', [
            'setSender', 'setFirstPartMail', 'setLastPartMail', 'setSubject', 'setSignature', 'setSentAt',
            'setEndAt', 'setEmailsValid', 'setEmailsWrong', 'setProviders', 'setCurrentStep', 'setMediaSuggestion',
            'setPeriodsConfig', 'resetState', 'setSelectedCriterias', 'setNoEmail', 'setSingleEmail'
        ]),
        getCmaj() {
            this.$global.loading = true

            this.$http.get('auth/campaigns/cmaj/providers/' + this.cmajId).then(res => {
                this.campaign = res.body.data.cmaj

                let batch = this.campaign.last_batch

                if (batch.sent_at !== null) {
                    let start = this.$moment(batch.sent_at)

                    this.setSentAt(start)
                }

                if (this.campaign.batches.length === 1 && window.location.href.indexOf("update") > -1) {
                    // Cas update 1er envoi
                    this.setProviders(batch.providers)
                } else {
                    // Cas création relances et update relances
                    this.setProviders(batch.providers_not_answered)
                }

                this.setFirstPartMail(batch.email_part1)
                this.setLastPartMail(batch.email_part2)
                this.setSender(this.campaign.sender)
                this.setSubject(batch.email_subject)
                this.setSignature(this.campaign.sender.signature)
                this.setMediaSuggestion(this.campaign.media_suggestion)
                this.setPeriodsConfig(this.campaign.periods_config)
                this.setNoEmail(this.campaign.no_email)
                this.setSingleEmail(this.campaign.single_email)
                this.setEmailLists()

                let criterias = this.campaign.apidae_criterias.map(criteria => criteria.external_id)

                this.setSelectedCriterias(criterias)

                this.$global.loading = false
            })
        },
        getContacts() {
            this.$http.get('auth/account/contacts').then(res => {
                this.contacts = res.body.data.contacts
            })
        },
        setEmailLists() {
            let emailsValid = []
            let emailsWrong = []

            this.providers.forEach(provider => {
                if (provider.contact === null) {
                    provider.error = 'Email non renseigné'
                    emailsWrong.push(provider)
                } else if (!EmailValidator.validate(provider.email)) {
                    provider.error = 'Mauvais format d\'email'
                    emailsWrong.push(provider)
                } else {
                    emailsValid.push(provider)
                }
            })

            this.setEmailsValid(emailsValid)
            this.setEmailsWrong(emailsWrong)
        },
        getInternalCriterias() {
            return this.$http.get('auth/account/apidae-criterias').then(res => {
                this.criterias = res.body.data.criterias
            })
        }
    },
    computed: {
        ...mapState('account', ['senders']),
        ...mapState('createCmaj', ['providers', 'currentStep']),
        aspectLabel() {
            if(this.aspect !== undefined && this.aspect !== '') {
                return aspectElements.find(aspect => {
                    return aspect.name === this.aspect
                }).label
            }
        },
    },
    created() {
        let hash = this.$route.params.hash
        this.cmajId = parseInt(atob(hash))

        if (this.$route.path.includes('update')) {
            this.update = true
        }

        this.resetState()

        this.$store.dispatch('account/loadSenders').then(() => {
            if (this.senders.length) {
                this.setSender(this.senders[0])
            }
        })

        this.getCmaj()
        this.getContacts()
        this.getInternalCriterias()

        this.$global.$on('change-step', (step) => {
            this.currentStep = step
        })
    },
    destroyed() {
        this.$global.$off('change-step')
    }
}
</script>